import Cookie from '@carvana/stc-cookie';
import { getUserState } from '@carvana/core-auth';

import type { BrowserData } from '../browserDataExtractor';
import { getBrowserData, getIpAddress } from '../browserDataExtractor';

type EventSourceContext = {
  eventSource?: string;
  eventAction?: string;
  eventSourceName?: string;
  eventSourceId?: string;
  eventTime: Date;
  eventName: string;
};

type CustomAttributes = {
  [key: string]: any;
};

type ClickStreamEvent = {
  visitorContext: {
    browserCookieId: string;
    userId: string;
    userAgent: string;
    clientIp: string;
  };
  browserContext: BrowserData;
  eventSourceContext: EventSourceContext;
  customAttributes: CustomAttributes;
};

const makeEvent = (
  eventSourceContext: EventSourceContext,
  customAttributes: CustomAttributes = {}
): ClickStreamEvent => {
  const { user } = getUserState();
  return {
    visitorContext: {
      browserCookieId: Cookie.getCookie('BrowserCookieId'),
      userId: user.user_id || null,
      userAgent: window.navigator.userAgent,
      clientIp: getIpAddress()
    },
    browserContext: getBrowserData(),
    eventSourceContext,
    customAttributes: {
      ...customAttributes
    }
  };
};

export { makeEvent, ClickStreamEvent, EventSourceContext, CustomAttributes };
